import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { filter, map, take } from 'rxjs/operators';
import * as fromAppConfigActions from '../state/app-config/app-config.actions';
import {
  selectCalendarConfigData,
  selectGlobalAppOptionsData,
  selectProjectConfigData,
  selectTodoPlannerConfigData,
} from '../state/app-config/app-config.selectors';
import { GlobalAppConfigModel } from '../models/app-config/global-app-config.model';
import { CalendarConfigModel } from '../models/app-config/calendar-config.model';
import { TodoPlannerConfigModel } from '../models/app-config/todo-planner-config.model';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  constructor(
    private readonly store: Store,
    private readonly actions$: Actions,
  ) {}

  public loadAppConfig(): Observable<unknown> {
    this.store.dispatch(fromAppConfigActions.fetchAppConfigData());

    return this.actions$.pipe(
      ofType(fromAppConfigActions.setAppConfigData),
      map((result) => result.payload),
      take(1),
    );
  }

  public getGlobalAppOptionsData(): Observable<GlobalAppConfigModel> {
    return this.store.select(selectGlobalAppOptionsData).pipe(filter((config) => !!config));
  }

  public getCalendarConfigData(): Observable<CalendarConfigModel> {
    return this.store.select(selectCalendarConfigData).pipe(filter((config) => !!config));
  }

  public getProjectConfigData(): Observable<unknown> {
    return this.store.select(selectProjectConfigData).pipe(filter((config) => !!config));
  }

  public getTodoPlannerConfigData(): Observable<TodoPlannerConfigModel> {
    return this.store.select(selectTodoPlannerConfigData).pipe(filter((config) => !!config));
  }
}
